import Dashboard, { DashboardLayout } from '.';
import UsefulLinks from 'src/ui/views/Dashboard/Tabs/UsefulLinks/UsefulLinks';

const UsefulLinksTab = ({ tab } = {
	tab: {
		text: 'useful links',
		content: <UsefulLinks />,
		requireWalletConnection: false,
	},
}) => <Dashboard selectedTab={tab} />;

UsefulLinksTab.Layout = DashboardLayout;

export default UsefulLinksTab;
